<template>
  <div class="teacher-manager">
    <!-- 面包屑导航 -->
    <div class="page-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>教学中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主内容区 -->
    <div class="teacher-content">
      <el-tabs v-model="activeName" type="card" class="teacher-tabs" @tab-click="handleClick">
        <!-- 学生管理标签页 -->
        <el-tab-pane label="学生管理" name="first">
          <div class="toolbar">
            <el-button type="primary" icon="el-icon-plus" class="add-btn" @click="openUserDialog()">
              新增学员
            </el-button>

            <el-form :inline="true" :model="formInline" class="search-form">
              <el-form-item label="登录账号">
                <el-input
                  v-model="formInline.loginAccount"
                  placeholder="请输入登录账号"
                  prefix-icon="el-icon-user"
                  clearable
                  @keyup.enter.native="selectStudent" />
              </el-form-item>
              <el-form-item label="姓名">
                <el-input
                  v-model="formInline.username"
                  placeholder="请输入姓名"
                  prefix-icon="el-icon-search"
                  clearable
                  @keyup.enter.native="selectStudent" />
              </el-form-item>
              <el-form-item class="btn-group">
                <el-button type="primary" icon="el-icon-search" @click="selectStudent">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetForm()">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 新增学员弹窗 -->
          <el-dialog
            title="新增学员"
            :visible.sync="dialogFormVisible"
            width="500px"
            custom-class="custom-dialog"
            :append-to-body="true">
            <el-form :model="user" ref="user" label-position="left" label-width="80px">
              <el-form-item label="登录账号">
                <el-input
                  v-model="user.loginAccount"
                  autocomplete="off"
                  maxlength="15"
                  prefix-icon="el-icon-user"
                  placeholder="请输入英文或数字或手机号"
                  clearable />
              </el-form-item>
              <el-form-item label="姓名">
                <el-input
                  v-model="user.username"
                  autocomplete="off"
                  maxlength="15"
                  prefix-icon="el-icon-postcard"
                  placeholder="请输入姓名"
                  clearable />
              </el-form-item>
              <el-form-item label="密码">
                <el-input
                  v-model="user.password"
                  autocomplete="off"
                  maxlength="15"
                  prefix-icon="el-icon-lock"
                  placeholder="请输入密码"
                  show-password
                  clearable />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取消</el-button>
              <el-button type="primary" @click="addUser()">确定</el-button>
            </div>
          </el-dialog>

          <!-- 修改学员弹窗 -->
          <el-dialog
            title="修改学员信息"
            :visible.sync="dialogFormVisible3"
            width="500px"
            custom-class="custom-dialog"
            :append-to-body="true">
            <el-form :model="updateUserBean" ref="updateUserForm" label-position="left" label-width="80px">
              <el-form-item label="登录账号">
                <el-input
                  v-model="updateUserBean.loginAccount"
                  autocomplete="off"
                  maxlength="20"
                  prefix-icon="el-icon-user"
                  disabled />
              </el-form-item>
              <el-form-item label="姓名">
                <el-input
                  v-model="updateUserBean.username"
                  autocomplete="off"
                  maxlength="10"
                  prefix-icon="el-icon-postcard"
                  placeholder="请输入姓名"
                  clearable />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible3 = false">取消</el-button>
              <el-button type="primary" @click="updateUser()">确定</el-button>
            </div>
          </el-dialog>


          <!-- 学生数据表格 -->
          <el-table
            :data="tableData"
            border
            stripe
            class="data-table"
            :header-cell-style="tableHeaderStyle"
            @expand-change="expandChange">
            <el-table-column type="index" label="#" width="80" align="center" class-name="index-column" />
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div class="expand-table-wrapper">
                  <el-table
                    :data="scope.row.examPaperAnswers"
                    :header-cell-style="expandTableHeaderStyle"
                    size="small">
                    <el-table-column type="index" label="#" width="50" align="center" class-name="index-column" />
                    <el-table-column prop="examPaperId" label="试卷编号" width="85" align="center" />
                    <el-table-column prop="paperName" label="试卷标题" min-width="150" show-overflow-tooltip />
                    <el-table-column prop="questionCount" label="题目数量" width="85" align="center" />
                    <el-table-column prop="paperScore" label="试卷总分" width="85" align="center" />
                    <el-table-column prop="userScore" label="得分" width="60" align="center" />
                    <el-table-column prop="doTime" label="耗时" width="60" align="center" />
                    <el-table-column prop="createTime" label="作答时间" width="160" align="center" />
                    <el-table-column label="操作" width="120" align="center">
                      <template slot-scope="{ row }">
                        <div class="action-btns">
                          <el-button type="text" @click="viewPaper(row.id)">查看</el-button>
                          <el-button type="text" @click="openScoreDialog(row)">评分</el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="loginAccount" label="账号" min-width="80" />
            <el-table-column prop="username" label="姓名" min-width="80" />
            <el-table-column prop="icode" label="代码编号" min-width="80" />
            <el-table-column prop="answerCount" label="答题次数" width="120" align="center" sortable />
            <el-table-column prop="createTime" label="注册时间" width="175" align="center" />
            <el-table-column label="操作" width="260" align="center" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="resetPassword(row.loginAccount)">
                  <i class="el-icon-refresh-left"></i> 重置密码
                </el-button>
                <el-button type="text" size="small" @click="openUpdateUserDialog(row)">
                  <i class="el-icon-edit"></i> 修改
                </el-button>
                <el-button type="text" size="small" class="danger-btn" @click="cancelLoginAccount(row.id)">
                  <i class="el-icon-delete"></i> 注销
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="pagination-wrapper">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="allInfo.total" />
          </div>
        </el-tab-pane>

        <!-- 试卷分析标签页 -->
        <el-tab-pane label="试卷分析" name="second">
          <div class="toolbar">
            <el-form :inline="true" :model="formInline2" class="search-form">
              <el-form-item label="试卷编号">
                <el-input
                  v-model="formInline2.id"
                  placeholder="请输入试卷编号"
                  prefix-icon="el-icon-document"
                  clearable
                  style="width: 150px"
                  @keyup.enter.native="getTestPaper" />
              </el-form-item>
              <el-form-item label="试卷标题">
                <el-input
                  v-model="formInline2.name"
                  placeholder="请输入试卷标题"
                  prefix-icon="el-icon-search"
                  clearable
                  style="width: 300px"
                  @keyup.enter.native="getTestPaper" />
              </el-form-item>
              <el-form-item class="btn-group">
                <el-button type="primary" icon="el-icon-search" @click="getTestPaper">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 试卷数据表格 -->
          <el-table
            :data="allTestPaperData"
            border
            stripe
            class="data-table"
            :header-cell-style="tableHeaderStyle"
            :default-sort="{ prop: 'id', order: 'descending' }"
            @expand-change="expandChange">
            <el-table-column type="index" label="#" width="80" align="center" class-name="index-column" />
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div class="expand-table-wrapper">
                  <el-table
                    :data="scope.row.examPaperAnswers"
                    :header-cell-style="expandTableHeaderStyle"
                    size="small">
                    <el-table-column type="index" label="#" width="50" align="center" class-name="index-column" />
                    <el-table-column prop="id" label="答题记录" width="100" align="center" />
                    <el-table-column prop="userInfo.loginAccount" label="学生账号" min-width="120" />
                    <el-table-column prop="userInfo.username" label="学生姓名" min-width="100" />
                    <el-table-column prop="userInfo.icode" label="代码编号" min-width="80" />
                    <el-table-column prop="userScore" label="得分" width="80" align="center">
                      <template slot-scope="{ row }">
                        <el-tag type="primary" size="small">{{ row.userScore }}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column prop="doTime" label="耗时" width="80" align="center" />
                    <el-table-column prop="createTime" label="答题时间" width="160" align="center" />
                    <el-table-column label="操作" width="120" align="center">
                      <template slot-scope="{ row }">
                        <div class="action-btns">
                          <el-button type="text" @click="viewPaper(row.id)">查看</el-button>
                          <el-button type="text"  @click="openScoreDialog(row)">评分</el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="试卷编号" width="100" align="center" />
            <el-table-column prop="name" label="试卷名称" min-width="300" show-overflow-tooltip />
            <el-table-column prop="score" label="试卷分数" width="100" align="center" />
            <el-table-column prop="questionCount" label="题目总数" width="100" align="center" />
            <el-table-column prop="answerCount" label="答题次数" width="120" align="center" sortable />
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="{ row }">
                <el-button
                  type="text"
                  icon="el-icon-s-order"
                  @click="openStudentWorkDialog(row.id, row.name)">
                  布置作业
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrapper">
            <el-pagination
              background
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="currentPage2"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize2"
              layout="total, sizes, prev, pager, next, jumper"
              :total="allInfo2.total" />
          </div>
        </el-tab-pane>

        <!-- 布置作业弹窗 -->
        <el-dialog
          title="布置作业 - 选择学员"
          :visible.sync="dialogStudentWork"
          width="600px"
          custom-class="custom-dialog"
          :append-to-body="true">
          <div class="assignment-header">
            <el-tag type="info" size="medium">
              <i class="el-icon-document"></i> {{ paperName }}
            </el-tag>
          </div>
          <el-table
            ref="multipleTable"
            :data="tableData4"
            tooltip-effect="dark"
            :header-cell-style="tableHeaderStyle"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column prop="loginAccount" label="账号" min-width="150" />
            <el-table-column prop="username" label="姓名" min-width="120" />
          </el-table>
          <div class="pagination-wrapper small">
            <el-pagination
              small
              background
              @size-change="handleSizeChange4"
              @current-change="handleCurrentChange4"
              :current-page="currentPage4"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize4"
              layout="total, prev, pager, next"
              :total="allInfo4.total" />
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogStudentWork = false">取消</el-button>
            <el-button type="primary" icon="el-icon-s-promotion" @click="assignment()">发布</el-button>
          </div>
        </el-dialog>

        <!-- 课堂管理标签页 -->
        <el-tab-pane label="课堂管理" name="six">
          <div class="toolbar">
            <el-form :inline="true" :model="formInline3" class="search-form">
              <el-form-item label="登录账号">
                <el-input
                  v-model="formInline3.loginAccount"
                  placeholder="请输入登录账号"
                  prefix-icon="el-icon-user"
                  clearable
                  @keyup.enter.native="selectStudentByClass" />
              </el-form-item>
              <el-form-item label="姓名">
                <el-input
                  v-model="formInline3.username"
                  placeholder="请输入姓名"
                  prefix-icon="el-icon-search"
                  clearable
                  @keyup.enter.native="selectStudentByClass" />
              </el-form-item>
              <el-form-item class="btn-group">
                <el-button type="primary" icon="el-icon-search" @click="selectStudentByClass">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 课堂记录弹窗 -->
          <el-dialog
            title="课堂记录"
            :visible.sync="dialogFormVisible2"
            width="520px"
            custom-class="class-record-dialog">
            <el-form :model="classForm" ref="classForm" label-position="top" class="class-record-form">
              <div class="form-section">
                <div class="section-label">
                  <i class="el-icon-document"></i>
                  <span>课堂内容</span>
                </div>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入本节课的教学内容..."
                  v-model="classForm.classContent"
                  resize="none" />
              </div>
              <div class="form-row">
                <div class="form-section half">
                  <div class="section-label">
                    <i class="el-icon-date"></i>
                    <span>上课日期</span>
                  </div>
                  <el-date-picker
                    v-model="classForm.startDate"
                    type="date"
                    placeholder="选择日期"
                    style="width: 100%" />
                </div>
                <div class="form-section half">
                  <div class="section-label">
                    <i class="el-icon-time"></i>
                    <span>上课时间</span>
                  </div>
                  <div class="time-range-box">
                    <el-time-select
                      placeholder="开始"
                      v-model="classForm.startTime"
                      :picker-options="timePickerOptions" />
                    <span class="time-separator">至</span>
                    <el-time-select
                      placeholder="结束"
                      v-model="classForm.endTime"
                      :picker-options="timePickerOptions" />
                  </div>
                </div>
              </div>
            </el-form>
            <div slot="footer" class="class-record-footer">
              <el-button @click="dialogFormVisible2 = false">取消</el-button>
              <el-button type="primary" @click="addClass()">保存</el-button>
            </div>
          </el-dialog>

          <!-- 课堂数据表格 -->
          <el-table
            :data="tableData3"
            border
            stripe
            class="data-table"
            :header-cell-style="tableHeaderStyle"
            @expand-change="expandChange">
            <el-table-column type="index" label="#" width="80" align="center" class-name="index-column" />
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div class="expand-table-wrapper">
                  <el-table
                    :data="scope.row.userClassInfos"
                    :header-cell-style="expandTableHeaderStyle"
                    size="small">
                    <el-table-column type="index" label="#" width="50" align="center" class-name="index-column" />
                    <el-table-column prop="id" label="课堂编号" width="100" align="center" />
                    <el-table-column prop="classContent" label="课堂内容" min-width="300" show-overflow-tooltip />
                    <el-table-column prop="startDate" label="上课日期" width="150" align="center" />
                    <el-table-column prop="classTime" label="上课时间" width="150" align="center" />
                    <el-table-column label="操作" width="120" align="center" fixed="right">
                      <template slot-scope="{ row }">
                        <el-button type="text" icon="el-icon-edit" @click="updateClass(row)">修改</el-button>
                        <el-button type="text" icon="el-icon-delete" class="danger-btn" @click="deleteUserClass(row.id)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="loginAccount" label="账号" min-width="120" />
            <el-table-column prop="username" label="姓名" min-width="100" />
            <el-table-column prop="icode" label="代码编号" min-width="100" />
            <el-table-column prop="classCount" label="上课次数" width="100" align="center" />
            <el-table-column prop="createTime" label="注册时间" width="175" align="center" />
            <el-table-column label="操作" width="140" align="center" fixed="right">
              <template slot-scope="{ row }">
                <el-button type="text" icon="el-icon-plus" @click="addClassDialog(row.loginAccount)">
                  添加记录
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrapper">
            <el-pagination
              background
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
              :current-page="currentPage3"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize3"
              layout="total, sizes, prev, pager, next, jumper"
              :total="allInfo3.total" />
          </div>
        </el-tab-pane>

        <!-- 试卷列表标签页 -->
        <el-tab-pane label="试卷列表" name="fourth">
          <div class="empty-placeholder">
            <i class="el-icon-document"></i>
            <p class="title">功能即将开放</p>
            <p class="desc">
              可将需要录入的试卷/试题发送至邮箱
              <a href="mailto:wancode@163.com">wancode@163.com</a>
              ，会有专员录题，录制完成后将第一时间通知您。
            </p>
          </div>
        </el-tab-pane>

        <!-- 题目列表标签页 -->
        <el-tab-pane label="题目列表" name="five">
          <div class="empty-placeholder">
            <i class="el-icon-tickets"></i>
            <p class="title">功能即将开放</p>
            <p class="desc">
              可将需要录入的试卷/试题发送至邮箱
              <a href="mailto:wancode@163.com">wancode@163.com</a>
              ，会有专员录题，录制完成后将第一时间通知您。
            </p>
          </div>
        </el-tab-pane>


      </el-tabs>

      <!-- 体验新版按钮 -->
      <el-button type="primary" class="vip-btn" @click="toWancodeVip()">
        <i class="el-icon-star-on"></i> 体验新版
      </el-button>

      <!-- 评分弹窗 -->
      <el-dialog
        title="更新得分"
        :visible.sync="dialogScoreVisible"
        width="400px"
        custom-class="custom-dialog"
        :append-to-body="true">
        <el-form :model="scoreInfo" ref="scoreInfo" label-position="top">
          <el-form-item label="人工评分">
            <el-input
              v-model="scoreInfo.score"
              type="number"
              autocomplete="off"
              maxlength="10"
              prefix-icon="el-icon-edit"
              placeholder="请输入分数"
              clearable />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogScoreVisible = false">取消</el-button>
          <el-button type="primary" @click="updateStudentScore()">确定</el-button>
        </div>
      </el-dialog>

      <!-- VIP提示弹窗 -->
      <el-dialog
        title=""
        :visible.sync="dialogVisible4"
        width="420px"
        center
        :show-close="false"
        custom-class="vip-premium-dialog"
        :before-close="handleClose">
        <div class="vip-premium-content">
          <!-- 关闭按钮 -->
          <div class="close-btn" @click="handleClose">
            <i class="el-icon-close"></i>
          </div>
          <!-- 顶部装饰 -->
          <div class="vip-header-decoration">
            <div class="crown-icon">
              <i class="el-icon-medal"></i>
            </div>
            <div class="sparkles">
              <span></span><span></span><span></span>
            </div>
          </div>
          <!-- 标题 -->
          <h3 class="vip-title">教师版会员专属</h3>
          <!-- 提示信息 -->
          <div class="vip-message-box">
            <i class="el-icon-info"></i>
            <p>{{ content }}</p>
          </div>
          <!-- 特权列表 -->
          <div class="vip-benefits">
            <div class="benefit-item">
              <i class="el-icon-user"></i>
              <span>学生管理</span>
            </div>
            <div class="benefit-item">
              <i class="el-icon-document"></i>
              <span>试卷分析</span>
            </div>
            <div class="benefit-item">
              <i class="el-icon-date"></i>
              <span>课堂管理</span>
            </div>
            <div class="benefit-item">
              <i class="el-icon-s-order"></i>
              <span>布置作业</span>
            </div>
          </div>
          <!-- 升级按钮 -->
          <el-button class="upgrade-btn" @click="toSelfVIP()">
            <i class="el-icon-unlock"></i>
            <span>立即升级会员</span>
          </el-button>
          <!-- 底部提示 -->
          <p class="vip-tip">开通教师版会员，解锁全部教学功能</p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  editClass,
  agentRegister,
  updateScore,
  updateUser,
  assignment,
  resetPassword,
  getStudentInfo2,
  getPaperListTwo,
  deleteUserClass,
  cancelLoginAccount,
} from '@/api/index.js'

export default {
  name: 'TeacherManage',

  data() {
    return {
      // 基础数据
      userId: '',
      divShow: false,
      content: '',
      activeName: 'first',

      // 学生管理分页
      allInfo: { total: 0 },
      currentPage: 1,
      pageSize: 10,
      tableData: [],

      // 试卷分析分页
      allInfo2: { total: 0 },
      currentPage2: 1,
      pageSize2: 10,
      allTestPaperData: [],

      // 课堂管理分页
      allInfo3: { total: 0 },
      currentPage3: 1,
      pageSize3: 10,
      tableData3: [],

      // 布置作业分页
      allInfo4: { total: 0 },
      currentPage4: 1,
      pageSize4: 10,
      tableData4: [],

      // 弹窗控制
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogScoreVisible: false,
      dialogVisible4: false,
      dialogStudentWork: false,

      // 表单数据
      user: {
        loginAccount: '',
        username: '',
        password: 'password',
      },
      updateUserBean: {
        id: '',
        loginAccount: '',
        username: '',
      },
      classForm: {
        id: '',
        loginAccount: '',
        classContent: '',
        startDate: '',
        startTime: '',
        endTime: '',
      },
      scoreInfo: {
        id: 0,
        score: 0,
      },

      // 搜索表单
      formInline: { loginAccount: '', username: '' },
      formInline2: { id: null, name: '' },
      formInline3: { loginAccount: '', username: '' },

      // 其他
      paperId: 0,
      paperName: '',
      userInfoList: [],
      isLoading: false,
    }
  },

  computed: {
    // 表格头部样式
    tableHeaderStyle() {
      return {
        background: '#f5f7fa',
        color: '#606266',
        fontWeight: '600'
      }
    },
    // 展开表格头部样式
    expandTableHeaderStyle() {
      return {
        background: '#eef1f6',
        color: '#606266'
      }
    },
    // 时间选择器配置
    timePickerOptions() {
      return {
        start: '08:00',
        step: '00:15',
        end: '23:30'
      }
    },
    // 获取教师ID
    teacherId() {
      return localStorage.getItem('userId')
    }
  },

  mounted() {
    this.initPage()
  },

  methods: {
    // ============ 初始化方法 ============
    initPage() {
      this.userId = this.teacherId
      if (this.userId) {
        this.divShow = true
        this.selectStudent()
      } else {
        this.divShow = false
      }
    },

    // ============ 工具方法 ============
    // 处理API响应
    handleApiResponse(res, successCallback) {
      if (res.code === '99995') {
        this.content = '您未开通【教师版会员】或会员已到期'
        this.dialogVisible4 = true
      } else if (res.code === '0000') {
        successCallback && successCallback(res)
      }
    },

    // 确认弹窗
    showConfirm(message, title = '提示') {
      return this.$confirm(message, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },

    // 根据得分返回标签类型
    getScoreTagType(score, total) {
      const ratio = score / total
      if (ratio >= 0.8) return 'success'
      if (ratio >= 0.6) return 'warning'
      return 'danger'
    },

    // ============ 导航方法 ============
    toWancodeVip() {
      window.open('http://www.wancode.vip', '_blank')
    },

    toSelfVIP() {
      this.dialogVisible4 = false
      this.$router.push({ name: 'selfVIP', params: { teacherPrise: '1' } })
    },

    viewPaper(id) {
      const route = this.$router.resolve({ path: `/viewTestPaper?id=${id}` })
      window.open(route.href, '_blank')
    },

    handleClose() {
      this.dialogVisible4 = false
    },

    // ============ Tab切换 ============
    handleClick(tab) {
      const handlers = {
        1: this.getTestPaper,
        2: this.selectStudentByClass
      }
      handlers[tab.index]?.()
    },

    expandChange() {},

    // ============ 学生管理 ============
    selectStudent() {
      const param = {
        loginAccount: this.formInline.loginAccount,
        username: this.formInline.username,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        teacherId: this.teacherId
      }
      getStudentInfo2(param).then(res => {
        this.handleApiResponse(res, () => {
          this.allInfo = res.data
          this.tableData = res.data.list
        })
      })
    },

    resetForm() {
      this.formInline = { loginAccount: '', username: '' }
      this.selectStudent()
    },

    openUserDialog() {
      this.user = { loginAccount: '', username: '', password: 'password' }
      this.dialogFormVisible = true
    },

    openUpdateUserDialog(row) {
      this.updateUserBean = { ...row }
      this.dialogFormVisible3 = true
    },

    addUser() {
      if (!this.user.loginAccount) return this.$message.error('请输入登录账号')
      if (!this.user.username) return this.$message.error('请输入姓名')
      if (!this.user.password) return this.$message.error('请输入密码')

      const param = {
        ...this.user,
        teacherId: this.teacherId
      }
      agentRegister(param).then(res => {
        if (res.code === '99995') {
          this.content = '您未开通【教师版会员】或会员已到期'
          this.dialogVisible4 = true
        } else if (res.code === '0000') {
          this.dialogFormVisible = false
          this.$message.success('注册成功')
          this.selectStudent()
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    updateUser() {
      if (!this.updateUserBean.loginAccount) return this.$message.error('请输入登录账号')
      if (!this.updateUserBean.username) return this.$message.error('请输入姓名')

      updateUser(this.updateUserBean).then(res => {
        if (res.code === '0000') {
          this.$message.success('修改成功')
        }
        this.dialogFormVisible3 = false
        this.selectStudent()
      })
    },

    resetPassword(loginAccount) {
      this.showConfirm('此操作是将密码重置为"password", 是否继续?').then(() => {
        resetPassword({ loginAccount }).then(res => {
          if (res.code === '0000') {
            this.$message.success('重置成功!')
          }
        }).catch(() => {
          this.$message.info('重置失败，可联系客服修改密码!')
        })
      }).catch(() => {
        this.$message.info('已取消重置')
      })
    },

    cancelLoginAccount(id) {
      this.$prompt('请输入您的登录密码', '此操作是将账号注销, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        const param = {
          password: value,
          id,
          belongTo: parseInt(this.teacherId),
        }
        cancelLoginAccount(param).then(res => {
          if (res.code === '0000') {
            this.$message.success('注销成功!')
            this.selectStudent()
          } else if (res.code === '99995') {
            this.$message.info(res.message)
          }
        }).catch(() => {
          this.$message.info('注销失败，可联系客服后台注销!')
        })
      }).catch(() => {
        this.$message.info('取消')
      })
    },

    // ============ 试卷分析 ============
    getTestPaper() {
      const param = {
        type: '',
        level: '',
        name: this.formInline2.name,
        id: this.formInline2.id,
        currentPage: this.currentPage2,
        pageSize: this.pageSize2,
      }
      getPaperListTwo(param).then(res => {
        this.handleApiResponse(res, () => {
          this.allInfo2 = res.data
          this.allTestPaperData = res.data.list
        })
      })
    },

    openScoreDialog(row) {
      this.scoreInfo = { id: row.id, score: row.userScore }
      this.dialogScoreVisible = true
    },

    updateStudentScore() {
      updateScore(this.scoreInfo).then(res => {
        if (res.code === '0000') {
          this.scoreInfo = { id: null, score: 0 }
          this.selectStudent()
          this.getTestPaper()
          this.$message.success('更新得分成功')
        }
        this.dialogScoreVisible = false
      }).catch(() => {
        this.dialogScoreVisible = false
      })
    },

    // ============ 布置作业 ============
    openStudentWorkDialog(paperId, paperName) {
      this.paperName = paperName
      this.paperId = paperId
      this.dialogStudentWork = true
      this.loadStudentsForWork()
    },

    loadStudentsForWork() {
      const param = {
        loginAccount: this.formInline3.loginAccount,
        username: this.formInline3.username,
        currentPage: this.currentPage4,
        pageSize: this.pageSize4,
        teacherId: this.teacherId
      }
      getStudentInfo2(param).then(res => {
        this.handleApiResponse(res, () => {
          this.allInfo4 = res.data
          this.tableData4 = res.data.list
        })
      })
    },

    handleSelectionChange(val) {
      this.userInfoList = val
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => this.$refs.multipleTable.toggleRowSelection(row))
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },

    assignment() {
      const param = {
        paperId: this.paperId,
        userInfoList: this.userInfoList,
        teacherId: this.teacherId
      }
      assignment(param).then(res => {
        if (res.code === '0000') {
          this.dialogStudentWork = false
          this.$message.success('发布成功')
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    // ============ 课堂管理 ============
    selectStudentByClass() {
      const param = {
        loginAccount: this.formInline3.loginAccount,
        username: this.formInline3.username,
        currentPage: this.currentPage3,
        pageSize: this.pageSize3,
        teacherId: this.teacherId
      }
      getStudentInfo2(param).then(res => {
        this.handleApiResponse(res, () => {
          this.allInfo3 = res.data
          this.tableData3 = res.data.list
        })
      })
    },

    addClassDialog(loginAccount) {
      this.classForm = {
        id: '',
        loginAccount,
        classContent: '',
        startDate: '',
        startTime: '',
        endTime: '',
      }
      this.dialogFormVisible2 = true
    },

    updateClass(row) {
      const [startTime, endTime] = (row.classTime || '').split('-')
      this.classForm = {
        id: row.id,
        loginAccount: row.loginAccount,
        classContent: row.classContent,
        startDate: row.startDate,
        startTime,
        endTime,
      }
      this.dialogFormVisible2 = true
    },

    addClass() {
      const { classContent, startDate, startTime, endTime } = this.classForm
      if (!classContent) return this.$message.error('请输入课堂内容')
      if (!startDate) return this.$message.error('请选择上课日期')
      if (!startTime) return this.$message.error('请选择开始时间')
      if (!endTime) return this.$message.error('请选择结束时间')

      const param = {
        ...this.classForm,
        classState: 3,
      }
      editClass(param).then(res => {
        if (res.code === '0000') {
          this.$message.success('记录成功')
        }
        this.dialogFormVisible2 = false
        this.selectStudentByClass()
      }).catch(() => {
        this.dialogFormVisible2 = false
      })
    },

    deleteUserClass(id) {
      this.showConfirm('此操作是删除课堂记录, 是否继续?').then(() => {
        deleteUserClass({ id }).then(res => {
          if (res.code === '0000') {
            this.$message.success('删除成功!')
          }
          this.selectStudentByClass()
        }).catch(() => {
          this.$message.info('删除失败，可联系客服!')
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },

    // ============ 分页处理 ============
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.selectStudent()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.selectStudent()
    },

    handleSizeChange2(val) {
      this.pageSize2 = val
      this.currentPage2 = 1
      this.getTestPaper()
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val
      this.getTestPaper()
    },

    handleSizeChange3(val) {
      this.pageSize3 = val
      this.currentPage3 = 1
      this.selectStudentByClass()
    },
    handleCurrentChange3(val) {
      this.currentPage3 = val
      this.selectStudentByClass()
    },

    handleSizeChange4(val) {
      this.pageSize4 = val
      this.currentPage4 = 1
      this.loadStudentsForWork()
    },
    handleCurrentChange4(val) {
      this.currentPage4 = val
      this.loadStudentsForWork()
    },
  }
}
</script>


<style lang="scss" scoped>
// ============ 变量定义 ============
$primary-color: #409eff;
$success-color: #67c23a;
$warning-color: #e6a23c;
$danger-color: #f56c6c;
$text-primary: #303133;
$text-regular: #606266;
$text-secondary: #909399;
$border-color: #dcdfe6;
$bg-color: #f5f7fa;
$shadow-light: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
$shadow-medium: 0 4px 16px 0 rgba(0, 0, 0, 0.12);
$transition-fast: 0.2s ease;
$transition-normal: 0.3s ease;

// ============ 主容器 ============
.teacher-manager {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  animation: fadeIn 0.4s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// ============ 面包屑导航 ============
.page-breadcrumb {
  margin: 20px 0;
  padding: 12px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  border-radius: 8px;
  box-shadow: $shadow-light;
  transition: box-shadow $transition-fast;

  &:hover {
    box-shadow: $shadow-medium;
  }
}

// ============ 主内容区 ============
.teacher-content {
  position: relative;
  min-height: 65vh;
  background: #fff;
  border-radius: 12px;
  box-shadow: $shadow-light;
  overflow: hidden;
}

// ============ Tabs样式 ============
.teacher-tabs {
  ::v-deep {
    .el-tabs__header {
      margin: 0;
      padding: 0 20px;
      background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);
      border-radius: 12px 12px 0 0;
      border: none !important;

      .el-tabs__nav-wrap {
        &::after {
          display: none !important;
        }
      }

      .el-tabs__nav {
        border: none !important;
        
        &.is-top {
          border: none !important;
        }
      }

      .el-tabs__item {
        color: rgba(255, 255, 255, 0.75);
        font-weight: 500;
        font-size: 15px;
        padding: 0 24px;
        height: 50px;
        line-height: 50px;
        border: none !important;
        border-left: none !important;
        border-right: none !important;
        border-top: none !important;
        border-bottom: none !important;
        transition: all $transition-fast;

        &:first-child {
          border-left: none !important;
        }

        &:hover {
          color: #fff;
        }

        &.is-active {
          color: #fff;
          background: rgba(255, 255, 255, 0.18);
          border-radius: 8px 8px 0 0;
          border: none !important;
        }
      }
    }

    .el-tabs__content {
      padding: 24px;
    }
  }
}

// ============ 工具栏 ============
.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px 20px;
  background: $bg-color;
  border-radius: 8px;

  .add-btn {
    flex-shrink: 0;
    border-radius: 8px;
    font-weight: 500;
    transition: all $transition-fast;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba($primary-color, 0.35);
    }
  }
}

// ============ 搜索表单 ============
.search-form {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;

  ::v-deep {
    .el-form-item {
      margin-bottom: 0;

      .el-form-item__label {
        color: $text-regular;
        font-weight: 500;
      }

      .el-input__inner {
        border-radius: 6px;
        transition: all $transition-fast;

        &:focus {
          box-shadow: 0 0 0 2px rgba($primary-color, 0.2);
        }
      }
    }
  }

  .btn-group {
    margin-left: auto;
  }
}

// ============ 数据表格 ============
.data-table {
  border-radius: 8px;
  overflow: hidden;

  ::v-deep {
    .el-table__header-wrapper {
      th {
        background: $bg-color !important;
        color: $text-primary;
        font-weight: 600;
        padding: 10px 0;
        border-bottom: 2px solid $border-color;
      }
    }

    .el-table__row {
      transition: all $transition-fast;

      &:hover > td {
        background: rgba($primary-color, 0.04) !important;
      }

      td {
        padding: 12px 0;
      }
    }

    // 单元格间距
    .el-table__cell {
      padding: 16px 8px !important;
    }

    // 移除表格边框
    tbody td {
      border-right: none !important;
    }

    thead th {
      border-right: none !important;
    }

    .el-button--text {
      padding: 4px 8px;
      font-weight: 500;

      &:hover {
        background: rgba($primary-color, 0.1);
        border-radius: 4px;
      }
    }
  }
}

// 展开表格包装器
.expand-table-wrapper {
  padding: 16px;
  background: #fafbfc;
  border-radius: 8px;
  margin: 8px 0;
}

// ============ 分页 ============
.pagination-wrapper {
  display: flex;
  justify-content: center;
  padding: 20px 0;

  &.small {
    padding: 12px 0;
  }

  ::v-deep {
    .el-pagination {
      .btn-prev, .btn-next, .el-pager li {
        border-radius: 6px;
        margin: 0 3px;
        transition: all $transition-fast;
      }

      .el-pager li.active {
        background: linear-gradient(135deg, $primary-color 0%, #1890ff 100%);
      }
    }
  }
}

// ============ 弹窗样式 ============
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 20px 24px 16px;
    background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: rgba(255, 255, 255, 0.8);

      &:hover {
        color: #fff;
      }
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid $border-color;
  }
}

// ============ VIP高级弹窗 ============
::v-deep .vip-premium-dialog {
  border-radius: 20px;
  overflow: visible;
  background: transparent;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
}

.vip-premium-content {
  position: relative;
  background: linear-gradient(180deg, #fff 0%, #faf8f5 100%);
  border-radius: 20px;
  padding: 40px 32px 32px;
  text-align: center;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);

  // 背景装饰
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);
    border-radius: 20px 20px 0 0;
  }

  // 关闭按钮
  .close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 10;

    i {
      color: rgba(255, 255, 255, 0.8);
      font-size: 16px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: rotate(90deg);

      i {
        color: #fff;
      }
    }
  }

  // 顶部装饰
  .vip-header-decoration {
    position: relative;
    margin-bottom: 24px;
    padding-top: 10px;

    .crown-icon {
      width: 72px;
      height: 72px;
      margin: 0 auto;
      background: linear-gradient(135deg, #f1c40f 0%, #f39c12 50%, #e67e22 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 8px 24px rgba(241, 196, 15, 0.5);
      animation: pulse 2s ease-in-out infinite;
      border: 4px solid #fff;

      i {
        font-size: 36px;
        color: #fff;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      }
    }

    .sparkles {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 120px;
      height: 120px;

      span {
        position: absolute;
        width: 8px;
        height: 8px;
        background: #f1c40f;
        border-radius: 50%;
        animation: sparkle 1.5s ease-in-out infinite;

        &:nth-child(1) {
          top: 0;
          left: 50%;
          animation-delay: 0s;
        }

        &:nth-child(2) {
          top: 25%;
          right: 0;
          animation-delay: 0.3s;
        }

        &:nth-child(3) {
          top: 25%;
          left: 0;
          animation-delay: 0.6s;
        }
      }
    }
  }

  // 标题
  .vip-title {
    font-size: 22px;
    font-weight: 700;
    color: #303133;
    margin-bottom: 16px;
    letter-spacing: 1px;
  }

  // 消息框
  .vip-message-box {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 20px;
    background: #fff5f5;
    border: 1px solid #ffccc7;
    border-radius: 8px;
    margin-bottom: 20px;

    i {
      color: #ff4d4f;
      font-size: 18px;
    }

    p {
      color: #434343;
      font-size: 14px;
      margin: 0;
    }
  }

  // 特权列表
  .vip-benefits {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-bottom: 24px;

    .benefit-item {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 14px;
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      transition: all 0.3s ease;

      &:hover {
        background: #fff;
        border-color: #409EFF;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
      }

      i {
        font-size: 18px;
        color: #409EFF;
      }

      span {
        color: #495057;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }

  // 升级按钮
  .upgrade-btn {
    width: 100%;
    height: 46px;
    background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);
    border: none;
    border-radius: 23px;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    letter-spacing: 1px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    box-shadow: 0 6px 20px rgba(64, 158, 255, 0.4);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.25), transparent);
      animation: shine 2s ease-in-out infinite;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 28px rgba(64, 158, 255, 0.5);
    }

    i {
      font-size: 16px;
    }
  }

  // 底部提示
  .vip-tip {
    margin-top: 14px;
    color: #909399;
    font-size: 12px;
  }
}

// 动画
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 8px 32px rgba(241, 196, 15, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 12px 40px rgba(241, 196, 15, 0.6);
  }
}

@keyframes sparkle {
  0%, 100% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes shine {
  0% {
    left: -100%;
  }
  50%, 100% {
    left: 100%;
  }
}

// ============ 布置作业 ============
.assignment-header {
  margin-bottom: 20px;
  padding: 12px 16px;
  background: $bg-color;
  border-radius: 8px;

  .el-tag {
    font-size: 14px;
    padding: 8px 16px;
  }
}

// ============ 课堂记录弹框 ============
::v-deep .class-record-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 18px 24px 14px;
    background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);

    .el-dialog__title {
      color: #fff;
      font-size: 17px;
      font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: rgba(255, 255, 255, 0.8);

      &:hover {
        color: #fff;
      }
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px 20px;
    border-top: 1px solid #ebeef5;
  }
}

.class-record-form {
  .form-section {
    margin-bottom: 18px;

    &.half {
      flex: 1;
      min-width: 0;
    }

    .section-label {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 8px;

      i {
        font-size: 15px;
        color: #409EFF;
      }

      span {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
      }
    }

    ::v-deep .el-textarea__inner {
      border-radius: 8px;
      border: 1px solid #dcdfe6;
      padding: 12px 14px;
      font-size: 14px;
      transition: all 0.2s ease;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
      }
    }

    ::v-deep .el-date-editor,
    ::v-deep .el-input {
      width: 100%;

      .el-input__inner {
        height: 40px;
        border-radius: 8px;
        font-size: 14px;
        transition: all 0.2s ease;

        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
        }
      }
    }
  }

  .form-row {
    display: flex;
    gap: 16px;
  }

  .time-range-box {
    display: flex;
    align-items: center;
    gap: 8px;

    ::v-deep .el-date-editor {
      flex: 1;
    }

    .time-separator {
      color: #909399;
      font-size: 13px;
      flex-shrink: 0;
    }
  }
}

.class-record-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 500;
  }
}

// ============ 时间范围选择 ============
.time-range {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-date-editor {
    flex: 1;
  }

  .time-separator {
    color: $text-secondary;
    font-size: 14px;
  }
}

// ============ 空占位 ============
.empty-placeholder {
  text-align: center;
  padding: 80px 40px;

  i {
    font-size: 80px;
    color: #d3dce6;
    margin-bottom: 24px;
  }

  .title {
    font-size: 20px;
    color: $text-primary;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .desc {
    font-size: 14px;
    color: $text-secondary;
    line-height: 1.8;
    max-width: 400px;
    margin: 0 auto;

    a {
      color: $primary-color;
      text-decoration: none;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

// ============ VIP按钮 ============
.vip-btn {
  position: absolute;
  top: 8px;
  right: 20px;
  z-index: 10;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8787 100%);
  border: none;
  color: #fff;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 24px;
  box-shadow: 0 4px 16px rgba(255, 107, 107, 0.4);
  transition: all $transition-fast;
  font-size: 14px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(255, 107, 107, 0.5);
    background: linear-gradient(135deg, #ff8787 0%, #ff5252 100%);
  }
}

// ============ 危险按钮 ============
.danger-btn {
  color: $danger-color !important;

  &:hover {
    background: rgba($danger-color, 0.1) !important;
  }
}

// ============ 全局修复 ============
body .el-table th.gutter {
  display: table-cell !important;
}
</style>

<style lang="scss">
// 表格行间距 - 全局样式覆盖
.teacher-manager .el-table .el-table__body td.el-table__cell {
  padding: 12px 8px !important;
}
.teacher-manager .el-table .el-table__header th.el-table__cell {
  padding: 12px 8px !important;
}

.teacher-manager .el-table td.index-column .cell,
.teacher-manager .el-table th.index-column .cell {
  white-space: nowrap !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
}

// 操作按钮横向排列
.action-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
</style>
